import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Tv from '@material-ui/icons/Tv';
import Handshake from 'Icons/Handshake';
import Accounts from 'Icons/Accounts';

import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import StepIndicator from 'Views/Onboarding/Components/StepIndicator';
import {
  useSignUpFlowContext,
} from 'Views/Onboarding/OnboardingHasUser/OnboardingHasUserContent/OnboardingHasUserContentRouter/SignUpFlow/SignUpFlowContext';

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
});

const STEP_ID_WEBSITE_AGREEMENT = 'websiteAgreement';
const STEP_ID_CLIENT_AGREEMENT = 'signUp';
const STEP_ID_SUBSCRIPTION_SETUP = 'signUpPayment';

const STEPS = [
  {
    stepId: STEP_ID_WEBSITE_AGREEMENT,
    IconComponent: Tv,
  },
  {
    stepId: STEP_ID_CLIENT_AGREEMENT,
    IconComponent: Handshake,
  },
  {
    stepId: STEP_ID_SUBSCRIPTION_SETUP,
    IconComponent: Accounts,
  },
];

const SignUpFlowStepIndicator = ({
  className,
  classes,
}) => {
  const { signUpStepsCollection, activeStep } = useSignUpFlowContext();
  const resources = signUpStepsCollection.resources().list();
  const includedStepMap = resources.reduce((acc, curr) => {
    acc[curr.attr('name')] = true;

    return acc;
  }, {});
  const steps = STEPS
    .filter((v) => {
      return includedStepMap[v.stepId];
    });

  const selectedStepId = activeStep?.attr('name') || STEP_ID_SUBSCRIPTION_SETUP;

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <StepIndicator
        steps={steps}
        selectedStepId={selectedStepId}
      />
    </Box>
  );
};

SignUpFlowStepIndicator.defaultProps = {
  className: '',
};

SignUpFlowStepIndicator.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SignUpFlowStepIndicator);
